// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3y3Hf","rootSuccess":"CompleteLink_rootSuccess__2GV3G","rootFailure":"CompleteLink_rootFailure__1qNw3","isDisabled":"CompleteLink_isDisabled__1wGjY"};